module.exports = __webpack_public_path__ + "static/About-dark-42558abe2e46477cae81c7e50d40d84e.svg";